import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { TXTWCL_For_more_help_with_withdrawals_ELL } from './HelpSectionContent.messages.json';

const HelpSectionContent: React.FC = () => (
  <Translation
    values={{
      a: (msg: React.ReactNode) => (
        <ResolverLink resolverTag={ResolverTag.HelpCenterDepositWithdrawal}>{msg}</ResolverLink>
      )
    }}
    {...TXTWCL_For_more_help_with_withdrawals_ELL}
  />
);

export default HelpSectionContent;
